import { formatToMaxFourDigits } from '@flexo/general';
import React from 'react';

const InformationCardContentCurlyTrees = ({ description, cardValue, t }) => {
  const valueString = cardValue?.value ? formatToMaxFourDigits(cardValue?.value) : '-.-';
  const placeholder = '%%';
  const treesWord = t('widgets.pollution.trees');
  const line2Template = t(description.line_2, { trees: placeholder });
  const [prefix, rawSuffix = ''] = line2Template.split(placeholder);
  const suffix = rawSuffix.replace(new RegExp(`^\\s*${treesWord}`), '');

  return (
    <div>
      <span>
        {t(description.line_1)}
        <br />
        {prefix}
        <span className="font-flexo-semibold">{`${valueString} ${treesWord}`}</span>
        {suffix}
      </span>
    </div>
  );
};

export default InformationCardContentCurlyTrees; 